<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Novo atendimento de procedimento</b>
						</h3>
					</div>
					<div class="box-body">
						<cabecalho-contrato :contrato-id="$route.params.contratoId"></cabecalho-contrato>
						<div class="row">
							<div class="col-md-6">
								<div :class="{'form-group': true, 'has-error':errors.has('profissional') }">
									<label>Profissional</label>
									<select-profissional name="profissional" :show-text-danger-profissional="showTextDangerProfissional" @setProfissionalSelecionado="(profissionalSelecionado)=>{setProfissionalSelecionado(profissionalSelecionado)}" v-validate="'required'"></select-profissional>
									<span v-show="errors.has('profissional')" class="help-block">{{ errors.first('profissional') }}</span>
								</div>
							</div>
							<div class="col-md-6" :class="{'has-error': showTextDangerProcedimento}">
								<div class="form-group">
									<label :class="{'erro-validacao': showTextDangerProcedimento}">Procedimento</label>
									<select-procedimento-contrato :semAgrupados="1" :show-text-danger-procedimento="showTextDangerProcedimento" :contrato-id="$route.params.contratoId" @setProcedimentoSelecionado="(procedimentoSelecionado)=>{setProcedimentoSelecionado(procedimentoSelecionado)}"></select-procedimento-contrato>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Sexo</label>
									<select class="form-control" v-model="dados.sexo">
										<option value="0">Ambos</option>
										<option value="1">Masculino</option>
										<option value="2">Feminino</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Idade mínima</label>
									<input type="number" class="form-control" v-model="dados.idade_minima">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Idade máxima</label>
									<input type="number" class="form-control" v-model="dados.idade_maxima">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Atendimentos</label>
									<input type="number" class="form-control" v-model="dados.quantidade_primeira">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Retorno</label>
									<input type="number" class="form-control" v-model="dados.quantidade_retorno">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Local</label>
									<input type="number" class="form-control" v-model="dados.quantidade_local">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Dia(s)</label>
									<label for="">Dia da semana: </label>
									<v-select id="select-dias" placeholder="Clique para selecionar o(s) dia(s)..." multiple v-model="dias" :options="selectDias"></v-select>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group" :class="{'has-error': showTextDangerHoraInicial}">
									<label>Hora inicial</label>
									<input type="time" class="form-control" v-model="dados.hora_inicial">
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group" :class="{'has-error': showTextDangerHoraFinal}">
									<label>Hora final</label>
									<input type="time" class="form-control" v-model="dados.hora_final">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<button @click="$router.go(-1)" class="btn btn-default pull-left"><span class="fa fa-reply"></span>	Voltar</button>
								<button @click="salvar()" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Salvar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http
	import selectProfissional from "../../cadastros/profissionais/selectProfissional";
	import selectProcedimentoContrato from "../contratos/selectProcedimentosContrato";
	import cabecalhoContrato from "../contratos/cabecarioContrato";
	export default {
		filters: {

		},
		data: () => ({
			showTextDangerProcedimento: false,
			showTextDangerProfissional: false,
			showTextDangerDias: false,
			showTextDangerHoraInicial: false,
			showTextDangerHoraFinal: false,
			dados: {
				profissional_id: '',
				contrato_procedimento_id: '',
				sexo: 0,
				idade_maxima: '',
				idade_minima: '',
				quantidade_primeira: '',
				quantidade_retorno: '',
				quantidade_local: '',
				hora_inicial: '',
				hora_final: '',
			},
			dias: [],
			selectDias: [{
					label: 'Domingo',
					value: '0'
				},
				{
					label: 'Segunda-feira',
					value: '1'
				},
				{
					label: 'Terça-feira',
					value: '2'
				},
				{
					label: 'Quarta-feira',
					value: '3'
				},
				{
					label: 'Quinta-feira',
					value: '4'
				},
				{
					label: 'Sexta-feira',
					value: '5'
				},
				{
					label: 'Sábado',
					value: '6'
				},
			]
		}),
		mounted() {},
		methods: {
			validar() {
				if (this.isEmpty(this.dados.profissional_id)) {
					this.showTextDangerProfissional = true;
				}
				if (this.isEmpty(this.dados.contrato_procedimento_id)) {
					this.showTextDangerProcedimento = true;
				}
				if (this.isEmpty(this.dados.hora_inicial)) {
					this.showTextDangerHoraInicial = true;
				}
				if (this.isEmpty(this.dados.hora_final)) {
					this.showTextDangerHoraFinal = true;
				}
				if (!this.hasDay()) {
					this.showTextDangerDias = true;
				}
				return true;
				/*
				if (this.isEmpty(this.dados.profissionalSolicitante)) {
					this.showTextDangerProfissional = true;
				}

				if (this.dados.procedimentos.length === 0) {
					this.showTextDangerProcedimento = true;
				}

				if (!this.showTextDangerPaciente && !this.showTextDangerProfissional && !this.showTextDangerProcedimento) {
					return true;
				}
				*/
			},
			setProfissionalSelecionado(profissionalSelecionado) {
				// this.showTextDangerProfissional = false;
				this.dados.profissional_id = profissionalSelecionado.id;
			},
			setProcedimentoSelecionado(procedimentoSelecionado) {
				this.dados.contrato_procedimento_id = procedimentoSelecionado.id;
			},
			salvar() {
				if (this.validar()) {
					this.$store.commit('TOGGLE_LOADING');
					axios
						.post(
							`${this.$store.state.serverURI}/api/administracao/agendas/createProcedimentoAtendimento`, {
								dados: this.dados,
								dias: this.dias
							},
							this.$store.getters.getHeaderAuth
						)
						.then(response => {
							this.$store.commit('TOGGLE_LOADING');
							this.$swal({
								type: "success",
								title: "Atendimento criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							this.$router.go(-1);
						})
						.catch(error => {
							this.$store.commit('TOGGLE_LOADING');
							var erros = error.response.data.message + " ";
							for (var erro of Object.values(error.response.data.errors)) {
								erros += erro + " \n";
							}
							this.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
				} else {
					this.$swal({
						type: "error",
						title: "Informações pendentes",
						text: "Preencha corretamente os campos destacados em vermelho!",
					});
				}
			},
			isEmpty(valor) {
				return valor === '';
			},
			hasDay() {
				// return this.dias.length > 0;
				return false;
			}
		},
		watch: {
			'dados.profissional_id': function() {
				this.showTextDangerProfissional = false;
			},
			'dados.contrato_procedimento_id': function() {
				this.showTextDangerProcedimento = false;
			}
		},
		components: {
			selectProfissional,
			selectProcedimentoContrato,
			cabecalhoContrato
		}
	}
</script>

<style>
	.v-select .dropdown-toggle {
		padding: 0 !important;
		border-radius: 0px !important;
	}

	.v-select input[type=search] {
		margin: 0 0 0 !important;
	}

	.v-select .selected-tag {
		margin: 5px !important;
	}
</style>



// WEBPACK FOOTER //
// novaAgendaProcedimentos.vue?801ead86